import Vue from 'vue'
import axios from 'axios'

import message from 'ant-design-vue/es/message'

const service = axios.create({
  baseURL: '/api',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    const token = Vue.ls.get('token')
    if (token) {
      config.headers['Access-Cookie'] = token // 让每个请求携带自定义 token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  res => {
    if (res.data.error) {
      const { error } = res.data
      if (error.code != 0) {
        message.error(
          error.msg.includes('token') ? `${error.msg}，请重新登录` : error.msg,
        )

        if (error.msg.includes('token')) {
          setTimeout(() => {
            window.location.href = window.location.origin
          }, 2000)
        }
      }
    }
    return res.data
  },

  error => {
    console.log('err' + error) // for debug
    message.error(error.message)
    return Promise.reject(error)
  }
)

export default service